<template>
	<el-dialog :visible.sync="visible" :title="title" width="540px" :before-close="handleClose" :close-on-click-modal="false">
		<p class="yx-color-text-primary pt-16 pb-8 fz-14 yx-pingfang-Medium ml-12" v-if="isEdit">
			该标签下，共
			<span class="yx-color-warning">{{ row.tag_use_count }}</span> 个达人
		</p>
		<el-form :model="form" label-width="80px" class="pt-16">
			<el-form-item label="标签名称" prop="tag_name">
				<el-input v-model="form.tag_name" placeholder="请输入（10字以内）" maxlength="10" show-word-limit />
			</el-form-item>
		</el-form>
		<div class="footer-dialog" slot="footer">
			<el-button @click="handleClose">取 消</el-button>
			<el-button type="primary" @click="submit" :disabled="isDisabled">确 认</el-button>
		</div>
	</el-dialog>
</template>
<script>
import { setTags } from '@/api/shopManage';
export default {
	computed: {
		isEdit({ dialogType }) {
			return dialogType === 'edit';
		},
		isDisabled() {
			return !this.form.tag_name;
		},
	},
	data() {
		return {
			visible: false,
			title: '',
			row: {},
			dialogType: 'add',
			form: {
				tag_name: '',
			},
		};
	},
	methods: {
		show(title, dialogType, row) {
			this.title = title;
			this.dialogType = dialogType;
			this.row = row;
			if (dialogType === 'edit') this.form.tag_name = row.tag_name || '';
			this.visible = true;
		},
		async submit() {
			let tags_id = undefined;
			const {
				form: { tag_name: tags_name },
				isEdit,
				row,
			} = this;
			if (isEdit) tags_id = row.id;
			const { code } = await setTags({ tags_id, tags_name, type: '1' }); //0商品标签， 1达人标签
			if (code !== 0) return;
			this.$message.success('操作成功');
			this.$emit('refreshList');
			this.handleClose();
		},
		handleClose() {
			this.form = {
				tag_name: '',
			};
			this.visible = false;
		},
	},
};
</script>
<style lang="scss" scoped>
</style>